module.exports = __webpack_public_path__ + "img/apple.434584c.png";